import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { DatInstancesState } from './types/index';

export { namespace } from './types/index';

export const state: DatInstancesState = {
  datInstancesState: {
    loading: {
      files: false,
      active: false,
      instanceByEid: false
    },
    error: {
      files: false,
      active: false,
      instanceByEid: false
    },
    fetched: {
      files: true,
      active: true,
      instanceByEid: true
    }
  },
  instances: [],
  errorMessage: '',
  fileByEid: undefined,
  notification: undefined
};

const namespaced = true;

export const module = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
